import { Snackbar } from "@material-ui/core";
import update from "immutability-helper";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { getAllSuppliers } from "../../reduxSaga/actions";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { Alert } from "@material-ui/lab";
import React from "react";
import $ from "jquery";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Check from "@material-ui/icons/Check";
import SettingsIcon from "@material-ui/icons/Settings";
import UploadAndDownloadService from "../../services/uploadAndDownloadFile";
import PurchaseService from "../../services/PurchaseOrder";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import UtilsFormule from "../../utils/UtilsFormule";
import ProductService from "../../services/ProductService";
import ManufacturingBatchService from "../../services/ManufacturingBatchService";
import CurrencyService from "../../services/CurrencyService";
import { Link, useNavigate } from "react-router-dom";
import RateService from "../../services/RateService";
import withLoader from "../../components/layouts/WithLoader";

const useQontoStepIconStyles = makeStyles({
  root: {
    color: "#eaeaf0",
    display: "flex",
    height: 22,
    alignItems: "center",
  },
  active: {
    color: "#000000",
  },
  circle: {
    width: 8,
    height: 8,
    color: "#fff",
    borderRadius: "50%",
    backgroundColor: "#000000",
  },
  completed: {
    color: "#000000",
    zIndex: 1,
    fontSize: 18,
  },
});

function QontoStepIcon(props) {
  const classes = useQontoStepIconStyles();
  const { active, completed } = props;

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
      })}
    >
      {completed ? (
        <Check className={classes.completed} />
      ) : (
        <div className={classes.circle} />
      )}
    </div>
  );
}

QontoStepIcon.propTypes = {
  active: PropTypes.bool,

  completed: PropTypes.bool,
};

const useColorlibStepIconStyles = makeStyles({
  root: {
    "& .MuiStepIcon-root.MuiStepIcon-active ": {
      backgroundColor: "#ccc",
      zIndex: 1,
      color: "#000",
      width: 50,
      height: 50,
      display: "flex",
      borderRadius: "50%",
      justifyContent: "center",
      alignItems: "center",
    },
  },
  active: {
    "& .MuiStepIcon-root.MuiStepIcon-active ": {
      color: "#000000",
    },
  },
  completed: {
    "& .MuiStepIcon-root.MuiStepIcon-completed": {
      color: "#000000",
    },
  },
});

function ColorlibStepIcon(props) {
  const classes = useColorlibStepIconStyles();
  const { active, completed } = props;

  const icons = {
    1: <SettingsIcon />,
  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      {icons[String(props.icon)]}
    </div>
  );
}

ColorlibStepIcon.propTypes = {
  active: PropTypes.bool,

  completed: PropTypes.bool,

  icon: PropTypes.node,
};

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiStepIcon-root.MuiStepIcon-active ": {
      width: "100%",
      color: "#000000",
    },
    "& .MuiStepIcon-root.MuiStepIcon-completed": {
      color: "#000000",
    },
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  icon: {
    color: "#000",
  },
}));

function getSteps() {
  return ["Inscrivez les produits ", "Créer un devis ", "Finaliser"];
}

const AddProductQuotation = ({ startLoading, stopLoading }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const suppliers = useSelector((state) => state.staff.suppliers.Societe);
  const [availableProducts, setAvailableProducts] = useState([]);
  const [quotationReference, setQuotationReference] = useState("");
  const [supplierId, setSupplierId] = useState(0);
  const [productId, setProductId] = useState(0);
  const [idLot, setIdLot] = useState(0);
  const [quantity, setQuantity] = useState(0);
  const [tva, setTva] = useState(0);
  const [devisReference, setDevisReference] = useState("");
  const [montantDevis, setMontantDevis] = useState(0);
  const [tauxChange, setTauxChange] = useState(0);
  const [promotionPercentage, setPromotionPercentage] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [unitPrice, setUnitPrice] = useState(0);
  const [productTableData, setProductTableData] = useState([]);
  const [productMapById, setProductMapById] = useState([]);
  const [promotionType, setPromotionType] = useState("pourcentage");
  const [discountType, setDiscountType] = useState("pourcentage");
  const [devisPriceTt, setDevisPriceTt] = useState(0);
  const [devisPriceHt, setDevisPriceHt] = useState(0);
  const [ordreTitle, setOrdreTitle] = useState("");
  const [devisImageFile, setDevisImageFile] = useState([]);
  const [ordreDesignation, setOrdreDesignation] = useState("");
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  const animatedComponents = makeAnimated();
  const classes = useStyles();
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedOptionLot, setSelectedOptionLot] = useState(null);
  const [selectedOptionDevis, setSelectedOptionDevis] = useState(null);
  const [deviseChoosen, setDeviseChoosen] = useState(null);

  const [supplierSelectedOption, setSupplierSelectedOption] = useState(null);
  const [availableDevisSelectedOption, setAvailableDevisSelectedOption] =
    useState(null);
  const [allAvailableDevis, setAllAvailableDevis] = React.useState([{}]);
  const [availableDevisSelectPlaceHolder, setAvailableDevisSelectPlaceHolder] =
    useState("Choisir...");
  const [allProducts, setAllProducts] = React.useState([{}]);
  const [allModeProduct, setAllModeProduct] = React.useState([
    { value: 1, label: "Local" },
    { value: 2, label: "Import" },
  ]);
  const [selectedOptionMode, setSelectedOptionMode] = useState(null);
  const [modeProduct, setModeProduct] = useState(null);

  const [allCurrencies, setAllCurrencies] = React.useState([
    { value: "EUR", label: "Euro" },
    { value: "USD", label: "US Dollar" },
    { value: "SAR", label: "Saudi Riyal" },
    { value: "AED", label: "United Arab Emirates Dirham" },
    { value: "CAD", label: "Canadian Dollar" },
    { value: "CNY", label: "Chinese Yuan" },
  ]);

  const [allSuppliers, setAllSuppliers] = React.useState([{}]);
  const [labelDevise, setLabelDevise] = useState("Prix en DNT");

  const [activeStep, setActiveStep] = React.useState(0);
  const [supplierSelectPlaceHolder, setSupplierSelectPlaceHolder] =
    useState("Choisir...");
  const [productSelectPlaceHolder, setProductSelectPlaceHolder] =
    useState("Choisir...");
  const [showProduct, setShowProduct] = useState(false);
  const [typeProduct, setTypeProduct] = useState(0);

  const [modeProductSelectPlaceHolder, setModeProductSelectPlaceHolder] =
    useState("Choisir...");
  const [deviseSelectPlaceHolder, setDeviseSelectPlaceHolder] =
    useState("Choisir...");
  const [lotSelectPlaceHolder, setLotSelectPlaceHolder] =
    useState("Choisir...");
  const [initialPriceHTC, setInitialPriceHTC] = useState(0);
  const [buyingPrice, setBuyingPrice] = useState(0);
  const [priceTT, setPriceTT] = useState(0);
  const [discountFinal, setDiscountFinal] = useState(0);
  const [availableLot, setAvailableLot] = useState([]);
  const [allLot, setAllLot] = useState([{ value: 0, label: "Aucun lot" }]);
  const [availableRates, setAvailableRates] = useState([]);
  const [allRates, setAllRates] = useState([]);

  const [rateSelectPlaceHolder, setRateSelectPlaceHolder] =
    useState("Choisir une taxe");
  const [rateChoosen, setRateChoosen] = useState(null);
  const [rateName, setRateName] = useState("");
  const [rateCode, setRateCode] = useState("");
  const [rateType, setRateType] = useState("");
  const [rateTypeTax, setRateTypeTax] = useState("");
  const [rateTypeTVA, setRateTypeTVA] = useState("");
  const [searchData, setSearchData] = useState("");

  const [valueRate, setValueRate] = useState();
  const [refBill, setRefBill] = useState("");
  const [rateValueTax, setRateValueTax] = useState("");

  const [rateTableData, setRateTableData] = useState([]);
  const [selectedOptionRate, setSelectedOptionRate] = useState(null);
  const steps = getSteps();
  const initialPending = useRef(3);
  // note par défaut : "Devis de {fournisseur}" tant que l'utilisateur ne l'a pas modifiée
  const noteEditedRef = useRef(false);
  const titleEditedRef = useRef(false);
  const initialRequestDone = () => {
    initialPending.current -= 1;
    if (initialPending.current === 0) stopLoading();
  };

  $(".custom-file-input").on("change", function () {
    var fileName = $(this).val().split("\\").pop();
    $(this).siblings(".custom-file-label").addClass("selected").html(fileName);
  });
  const styles = {
    container: (base) => ({
      ...base,
      flex: 1,
    }),
    // le menu doit passer au-dessus du champ fichier (.custom-file-input a z-index: 2)
    menu: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  };
  useEffect(() => {
    dispatch(getAllSuppliers());
    startLoading();
    initialPending.current = 3;
    ManufacturingBatchService.getManufacturingBatchByIdUser(
      getCurrentUserId(),
      0
    )
      .then((response) => {
        setAvailableLot(response.data);
      })
      .catch(() => {})
      .finally(initialRequestDone);
    RateService.getAllRatesByIdUserAndIsDeletedAndTypeTax(
      getCurrentUserId(),
      0,
      1
    )
      .then((result) => {
        console.log("result", result.data["success"]);
        if (result.data["success"]) {
          setAvailableRates(result.data["success"]);
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur :erreur serveur ");
        }
      })
      .catch(() => {})
      .finally(initialRequestDone);
  }, []);
  useEffect(() => {
    setAllRates([]);

    availableRates &&
      availableRates.map((element, i) => {
        setAllRates((oldArray) => [
          ...oldArray,
          {
            value: element.id,
            label: element.name,
            customElements: {
              code: element.code,
              type: element.type,
              value: element.value,
              typeTVA: element.typeTVA,
              typeTax: element.typeTax,
            },
          },
        ]);
      });
  }, [availableRates]);

  useEffect(() => {
    suppliers &&
      suppliers.map((element, i) => {
        let exist = false;
        if (allSuppliers.length !== 0) {
          for (let index = 0; index < allSuppliers.length; index++) {
            if (allSuppliers[index].value === element?.id) {
              exist = true;
              break;
            }
          }
        }

        if (element?.id !== undefined && exist === false) {
          setAllSuppliers((oldArray) => [
            ...oldArray,
            { value: element.id, label: element.title },
          ]);
        }
      });
  }, [suppliers]);


  useEffect(() => {
    availableLot &&
      availableLot.map((element) => {
        setAllLot((oldArray) => [
          ...oldArray,
          { value: element.id, label: element.serialNumber },
        ]);
      });
  }, [availableLot]);

  useEffect(() => {
    PurchaseService.getAllDevisNotArchived()
      .then((response) => {
        if (Object.keys(response.data)[0] === "empty") {
          setAvailableDevisSelectPlaceHolder("Vide");
        } else if (Object.keys(response.data)[0] === "success") {
          let backendData = [{}];
          response.data.success.map((element) => {
            let elem = { value: element, label: element };
            backendData.push(elem);
          });
          setAllAvailableDevis(backendData);
          setAvailableDevisSelectPlaceHolder("Choisir...");
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connection");
      })
      .finally(() => {
        initialRequestDone();
      });
  }, []);

  function etatInitial() {
    setSelectedOption(null);
    setProductSelectPlaceHolder("Choisir...");
    setUnitPrice(0);
    setQuantity(0);
    setTva(0);
    setSelectedOptionMode(null);
    setPromotionType("pourcentage");
    setPromotionPercentage(0);
    setSelectedOptionLot(null);
    setSupplierSelectedOption(null);
    setLotSelectPlaceHolder("Choisir...");
    setShowProduct(false);
  }

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  const onChangeQuantityHandler = (event) => {
    setQuantity(event.target.value);
  };

  const onChangeOrdreTitleHandler = (event) => {
    titleEditedRef.current = event.target.value.trim() !== "";
    setOrdreTitle(event.target.value);
  };

  const onChangeOrdreDesignationHandler = (event) => {
    noteEditedRef.current = event.target.value.trim() !== "";
    setOrdreDesignation(event.target.value);
  };

  const onChangeUnitPriceHandler = (event) => {
    setUnitPrice(event.target.value);
    setLabelDevise("Prix U en DNT");
    setMontantDevis(event.target.value);
  };
  const onChangeMontantDevisHandler = (event) => {
    setMontantDevis(0);
    setMontantDevis(event.target.value);
  };

  const onChangeTvaHandler = (event) => {
    setTva(event.target.value);
  };
  const onChangeDevisHandler = (event) => {
    setDevisReference(event.target.value);
  };
  const onChangePromotionHandler = (event) => {
    if (event.target.value === "") {
      setPromotionPercentage(0);
    } else {
      setPromotionPercentage(event.target.value);
    }
  };
  const onChangeDiscountHandler = (event) => {
    setDiscount(event.target.value);
    CalculateNewPurchasingPriceAfterDiscount(event.target.value, discountType);
  };

  const onChangeDiscountTypeHandler = (event) => {
    setDiscountType(event.target.value);
    CalculateNewPurchasingPriceAfterDiscount(discount, event.target.value);
  };
  const CalculateNewPurchasingPriceAfterDiscount = (discount, discountType) => {
    let result = UtilsFormule.CalculateNewPurchasingPriceAfterDiscount(
      productTableData,
      discount,
      discountType
    );
    console.log("result discount", result);
    let sumPromotionHt = result[1];
    let sumPromotionTt = result[2];
    let sumPriceHt = result[3];

    setDevisPriceHt(sumPromotionHt);
    setDevisPriceTt(sumPromotionTt);
    setInitialPriceHTC(sumPriceHt);
    setBuyingPrice(sumPromotionHt);
    setPriceTT(sumPromotionTt);
    setDiscountFinal(result[4]);
    // setProductTableData(result[5]);
    // console.log("listProduct", productTableData);
  };

  const onChangeQuotationReferenceHandler = (selectedOptionn) => {
    setQuotationReference(selectedOptionn.value);
    setAvailableDevisSelectedOption();
    setAvailableDevisSelectPlaceHolder(selectedOptionn.label);
  };

  const onDeleteProduct = (id) => {
    setProductTableData(productTableData.filter((item) => item.id !== id));
    setProductMapById(productMapById.filter((item) => item.id !== id));
  };

  const onGetQuotationByReference = () => {
    if (quotationReference === "") {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : Aucune réference");
    } else {
      startLoading();
      PurchaseService.getDevisByRef(quotationReference)
        .then((response) => {
          if (Object.keys(response.data)[0] === "success") {
            // certains produits de l'ancien devis peuvent ne plus exister
            const missingProducts = [];
            const validPurchases = (response.data.success.purchases || []).filter(
              (element) => {
                const product = element.product;
                const unavailable =
                  !product ||
                  product.id === undefined ||
                  product.id === null ||
                  product.isDeleted === 1 ||
                  product.isDeleted === true;
                if (unavailable) {
                  missingProducts.push(
                    product && product.name
                      ? product.name
                      : "produit n°" + (element.idProduct || element.id || "?")
                  );
                }
                return !unavailable;
              }
            );

            if (validPurchases.length === 0 && missingProducts.length > 0) {
              setOpenErrorAlert(true);
              setErrorAlertText(
                "Erreur : aucun produit de ce devis n'existe plus dans le système"
              );
              return;
            }

            setProductMapById([]);
            setProductTableData([]);
            console.log(response.data.success);

            if (missingProducts.length > 0) {
              setOpenInfoAlert(true);
              setInfoAlertText(
                missingProducts.length +
                  " produit(s) inexistant(s) ignoré(s) : " +
                  missingProducts.join(", ")
              );
            }

            validPurchases.forEach((element) => {
              let lot = 0;
              if (element.manufacturingBatch != null) {
                lot = element.manufacturingBatch.id;
              }
              setProductMapById((previoustate) => [
                ...previoustate,
                {
                  productRef: element.product.name,
                  idProduct: element.product.id,
                  initialPriceHtc: element.initialPriceHtc,
                  quantity: element.quantity,
                  tva: element.tva,
                  buyingPriceU: element.buyinfPrice,
                  idLot: lot,
                  currency: element.currency,
                  currencyPrice: element.currencyPrice,
                  exchangeRate: element.exchangeRate,
                  isImport: element.isImport,
                  htPrice: element.buyinfPrice * element.quantity,
                  ttPrice: element.priceTt * element.quantity,
                  promotionPercentage: element.promotionPercentage,
                },
              ]);
              setProductTableData((previoustate) => [
                ...previoustate,
                {
                  productRef: element.product.name,
                  idProduct: element.product.id,
                  initialPriceHtc: element.initialPriceHtc,
                  quantity: element.quantity,
                  tva: element.tva,
                  currency: element.currency,
                  currencyPrice: element.currencyPrice,
                  exchangeRate: element.exchangeRate,
                  isImport: element.isImport,
                  buyingPriceU: element.buyinfPrice,
                  idLot: lot,
                  htPrice: element.buyinfPrice * element.quantity,
                  ttPrice: element.priceTt * element.quantity,
                  promotionPercentage: element.promotionPercentage,
                },
              ]);
            });

            response.data.success.ratePPs.forEach((element) => {
              setRateTableData((previoustate) => [
                ...previoustate,
                {
                  idRate: element.idRate,
                  name: element.name,
                  value: element.value,
                  code: element.code,
                  type: element.type,
                  typeTax: element.typeTax,
                  typeTVA: element.typeTVA,
                  refBill: element.refBill,
                },
              ]);
            });
          } else if (Object.keys(response.data)[0] === "empty") {
            setOpenInfoAlert(true);
            setInfoAlertText("info : aucun devis avec ce réference");
          }
        })
        .catch((e) => {
          setOpenErrorAlert(true);
          setErrorAlertText(
            "Erreur : impossible d'importer les produits de ce devis"
          );
          console.log("error getDevisByRef", e);
        })
        .finally(() => stopLoading());
    }
  };

  const handleNext = () => {
    if (activeStep === 0) {
      let result = UtilsFormule.CalculateNewPurchasingPriceAfterDiscount(
        productTableData,
        discount,
        discountType
      );
      console.log("result discount handleNext", result);

      let sumPromotionHt = result[1];
      let sumPromotionTt = result[2];
      let sumPriceHt = result[3];

      setDevisPriceHt(sumPromotionHt);
      setDevisPriceTt(sumPromotionTt);
      setInitialPriceHTC(sumPriceHt);
      setBuyingPrice(sumPromotionHt);
      setPriceTT(sumPromotionTt);
      setDiscountFinal(result[4]);
    }
    if (activeStep === 0 && productTableData.length > 0) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    } else if (activeStep === 0 && productTableData.length === 0) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : Aucun produit ");
    } else if (activeStep === 1 && ordreTitle === "") {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : Le champ de titre est vide ");
    } else if (activeStep === 1 && supplierId === 0) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : aucun fournisseur ");
    } else if (activeStep === 1 && ordreDesignation === "") {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : aucune description ");
    } else if (activeStep === 1 && devisReference === "") {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : aucun réference ");
    } else if (activeStep === 1) {
      startLoading();
      PurchaseService.verifieDevisExistanceByReference(devisReference)
        .then((response) => {
          if (Object.keys(response.data)[0] === "NotExist") {
            setProductTableData(
              UtilsFormule.CalculateNewPurchasingDataTableAfterDiscount(
                productTableData,
                discountFinal
              )
            );
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
            console.log("Products after discount", productTableData);
          } else if (Object.keys(response.data)[0] === "Exist") {
            setOpenInfoAlert(true);
            setInfoAlertText("Info : ce réference existe dans le system  ");
          }
        })
        .catch((e) => {
          setOpenErrorAlert(true);
          setErrorAlertText(e);
        })
        .finally(() => stopLoading());
    } else if (activeStep === 2) {
      let devisModel = {
        buyingPrice: buyingPrice,
        description: ordreDesignation,
        discountPercentage: discountFinal,
        idSupplier: supplierId,
        idUser: getCurrentUserId(),
        initialPriceHtc: initialPriceHTC,
        note: ordreDesignation,
        path: "string",
        priceHT: devisPriceHt,
        priceTT: priceTT,
        ref: devisReference,
        purchases: productTableData,
        title: ordreTitle,
        ratePPps: rateTableData,
      };
      console.log("devisModel :", devisModel);

      // pas de loader de page ici : les requêtes POST affichent déjà l'overlay global
      if (devisImageFile.length !== 0) {
        const uploadData = new FormData();
        uploadData.append("picture", devisImageFile);

        UploadAndDownloadService.uploadFile(
          "/retail/uploadFile/uploadFile/devis",
          uploadData
        )
          .then((response) => {
            if (Object.keys(response.data)[0] === "success") {
              devisModel.path = response.data.success;
              onSendQuotationToBackendSystem(devisModel);
            } else {
              setOpenErrorAlert(true);
              setErrorAlertText("Erreur : il ya un erreur");
            }
          })
          .catch((e) => {
            setOpenErrorAlert(true);
            setErrorAlertText(e);
          });
      } else {
        devisModel.path = "any";
        onSendQuotationToBackendSystem(devisModel);
      }
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    window.location.reload(false);
  };

  const onChangeSelectedProduct = (selectedOptionn) => {
    setSelectedOption();
    setProductId(selectedOptionn.value);
    setProductSelectPlaceHolder(selectedOptionn.label);
    // setShowProduct(true);
    setTypeProduct(selectedOptionn.customElements);
    startLoading();
    ProductService.getLastProductPurchasePrice(getCurrentUserId(), selectedOptionn.value).then((response) => {
      if (response.data.success) {
        setUnitPrice(response.data.success);
        setLabelDevise("Prix U en DNT");
        setMontantDevis(response.data.success);
      }
      setShowProduct(true);


    }).catch((error) => {
      console.log(error);
    }).finally(() => {
      stopLoading();
    });

  };
  const onChangeSelectedDevis = (selectedOptionn) => {
    setSelectedOptionDevis(selectedOptionn.value);
    setDeviseChoosen(selectedOptionn.value);
    setDeviseSelectPlaceHolder(selectedOptionn.label);
  };
  const onChangeSelectedMode = (selectedOptionn) => {
    setSelectedOptionMode(selectedOptionn.value);
    setModeProduct(selectedOptionn.value);
    setModeProductSelectPlaceHolder(selectedOptionn.label);
  };
  const onChangeSelectedLot = (selectedOptionn) => {
    setSelectedOptionLot();
    setIdLot(selectedOptionn.value);
    setLotSelectPlaceHolder(selectedOptionn.label);
  };
  const onChangeSelectedSupplier = (selectedOptionn) => {
    if (!noteEditedRef.current && selectedOptionn && selectedOptionn.label) {
      setOrdreDesignation("Devis de " + selectedOptionn.label);
    }
    if (!titleEditedRef.current && selectedOptionn && selectedOptionn.label) {
      setOrdreTitle("Devis de " + selectedOptionn.label);
    }
    setSupplierSelectedOption();
    setSupplierId(selectedOptionn.value);
    setSupplierSelectPlaceHolder(selectedOptionn.label);
  };
  const onUploadFileHandler = (e) => {
    if (e.target.files[0].size > 2097152) {
      setOpenInfoAlert(true);
      setInfoAlertText("la taille du fichier ne doit pas dépasser 2 Mo");
    } else {
      setDevisImageFile(e.target.files[0]);
    }
  };
  const onSendQuotationToBackendSystem = (devisModel) => {
    console.log("devisModel", JSON.stringify(devisModel));
    PurchaseService.addDevis(devisModel)
      .then((response) => {
        if (Object.keys(response.data)[0] === "Devis") {
          setActiveStep((prevActiveStep) => prevActiveStep + 1);
          setOpenSuccessAlert(true);
          setSuccessAlertText("Enregistrement avec succées");
          setTimeout(() => {
            navigate(`/allQuotation`);
          }, 2000);
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : il ya un erreur  ");
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connexion");
      });
  };
  const getCurrencyRate = (deviseChoosen) => {
    try {
      startLoading();
      CurrencyService.getTauxChage(deviseChoosen).then((response) => {
        console.log("response");
        setTauxChange(response.data);

        setLabelDevise(
          "TAUX D'ECH (" +
          response.data.toLocaleString(undefined, {
            maximumFractionDigits: 3,
          }) +
          ") ESTI DNT (" +
          (unitPrice * response.data).toLocaleString(undefined, {
            maximumFractionDigits: 3,
          }) +
          " )"
        );
      })
        .catch((error) => {
          console.log("error currency", error);
        })
        .finally(() => stopLoading());
    } catch (error) {
      stopLoading();
      console.log("error currency", error);
    }
  };
  const onHandleClickTauxChange = () => {
    if (deviseChoosen !== null) {
      getCurrencyRate(deviseChoosen);
    }
  };
  const labelDeviseTest = () => {
    return labelDevise;
  };
  const calculDevis = () => {
    return (
      <div className="col-sm-6">
        <div className="input-group">
          <label>{labelDeviseTest()}</label>
          <div className="input-group-prepend" style={{ width: "89%" }}>
            <input
              onChange={onChangeMontantDevisHandler}
              type="number"
              min="0"
              id="montantDevise"
              className="form-control"
            />
          </div>
          <div className=" input-group-append">
            <button
              onClick={onHandleClickTauxChange}
              type="button"
              class="btn btn-dark"
            >
              {" "}
              <i class="fas fa-solid fa-dollar-sign"></i>{" "}
            </button>
          </div>
        </div>
      </div>
    );
  };

  const devise = () => {
    if (modeProduct === 2) {
      return (
        <div className="col-sm-8">
          <div className="row">
            <div className="col-sm-6">
              <div className="form-group">
                <label>Devise</label>
                <Select
                  closeMenuOnSelect={true}
                  components={animatedComponents}
                  defaultValue={selectedOptionDevis}
                  onChange={onChangeSelectedDevis}
                  options={allCurrencies}
                  placeholder={deviseSelectPlaceHolder}
                />
              </div>
            </div>
            {calculDevis()}
          </div>
        </div>
      );
    }
  };
  const onChangeSelected = (selectedOption) => {
    console.log("selected", selectedOption);
    setSelectedOptionRate(selectedOption);
    setRateChoosen(selectedOption.value);
    setRateName(selectedOption.label);
    setRateCode(selectedOption.customElements.code);
    setRateType(selectedOption.customElements.type);
    setRateTypeTax(selectedOption.customElements.typeTax);
    setRateTypeTVA(selectedOption.customElements.typeTVA);
    setRateSelectPlaceHolder(selectedOption.label);
    // setRateValueTax(selectedOption.customElements.value)
    setValueRate(selectedOption.customElements.value);
  };
  const onChangeValueRateHandler = (event) => {
    setValueRate(event.target.value);
  };
  const onAddTaxeToList = (event) => {
    let rateId = null;
    let exist = false;
    let indexInRateTable;
    try {
      rateTableData.forEach((element, index) => {
        console.log("element", element);

        if (element.code === rateCode) {
          indexInRateTable = index;
          exist = true;
          throw "Break";
        }
      });
    } catch (e) {
      if (e !== "Break") throw e;
    }
    console.log("exist", exist);
    if (rateChoosen === null) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : Sélectionnez un taxe ");
    }
    if (valueRate == null) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur :le valeur est vide ! ");
    } else {
      if (!exist) {
        setRateTableData((previoustate) => [
          ...previoustate,
          {
            idRate: rateChoosen,
            name: rateName,
            value: valueRate,
            code: rateCode,
            type: rateType,
            typeTax: rateTypeTax,
            typeTVA: rateTypeTVA,
            refBill: refBill,
          },
        ]);
      } else if (exist) {
        let rateUpdateValue = rateTableData[indexInRateTable];

        if (rateTableData[indexInRateTable].value !== valueRate) {
          setOpenInfoAlert(true);
          setInfoAlertText(
            "Info : Vous avez actualisé la valeur de " + rateName
          );
        }
        rateUpdateValue.idRate = rateChoosen;
        rateUpdateValue.name = rateName;
        rateUpdateValue.value = valueRate;
        rateUpdateValue.code = rateCode;
        rateUpdateValue.type = rateType;
        rateUpdateValue.typeTax = rateTypeTax;
        rateUpdateValue.typeTVA = rateTypeTVA;
        rateUpdateValue.refBill = refBill;
        let modelData = update(rateTableData, {
          [indexInRateTable]: { $merge: rateUpdateValue },
        });

        setRateTableData(modelData);
      }
      setRefBill("");
      setRateChoosen(null);
      setRateSelectPlaceHolder("choisir une taxe");
      setRateName("");
      setRateCode("");
      setRateType("");
      setValueRate("");
    }
  };
  const onChangeRefBillHandler = (event) => {
    setRefBill(event.target.value);
  };
  const blocRefFacture = () => {
    if (rateTypeTax === 2 && rateType === 1) {
      return (
        <div className="col-md-5">
          <label>Référence facture:</label>
          <input
            type="Ref"
            className="form-control"
            placeholder="Ajouter Référence"
            value={refBill}
            onChange={onChangeRefBillHandler}
          />
        </div>
      );
    } else {
      return <div className="col-md-5"></div>;
    }
  };
  const blocRates = () => {
    if (rateChoosen !== null) {
      if (rateTypeTax === 1) {
        return (
          <>
            <div className="col-md-6">
              <label>Valeur:</label>
              <input
                onChange={onChangeValueRateHandler}
                type="number"
                value={valueRate}
                min="0"
                id="unitPrice"
                className="form-control"
                disabled
              />
            </div>
            {blocRefFacture()}
          </>
        );
      } else if (rateTypeTax === 2) {
        return (
          <>
            <div className="col-md-6">
              <label>Valeur:</label>
              <input
                onChange={onChangeValueRateHandler}
                type="number"
                value={valueRate}
                min="0"
                id="unitPrice"
                className="form-control"
              />
            </div>
            {blocRefFacture()}
          </>
        );
      }
    }
  };
  const blocButtonAddRates = () => {
    if (rateChoosen !== null) {
      return (
        <div className="row">
          <div className="col-md-8"></div>
          <div className="col-md-4">
            <button class="btn btn-dark  float-right" onClick={onAddTaxeToList}>
              <i class="fas fa-plus"></i>
              Ajouter taxe
            </button>
          </div>
        </div>
      );
    }
  };
  function buttonFormatter(cell, row) {
    if (row.typeTax === 1) {
      if (row.typeTVA === 1) {
        // return <span>Tax, avant TVA</span>;
        return <span>Tax, sur HTC</span>;
      } else if (row.typeTVA === 2) {
        // return <span>Tax, après TVA</span>;
        return <span>Tax, sur TTC</span>;
      }
    } else if (row.typeTax === 2) {
      if (row.type === 1) {
        return <span>Charge, avec facture</span>;
      } else if (row.type === 2) {
        return <span>Charge, sans facture</span>;
      }
    }
  }
  const columnsRate = [
    {
      dataField: "code",
      text: "Code",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "name",
      text: "Libellé",
      align: "center",
      headerAlign: "center",
    },
    {
      dataField: "typeTax",
      text: "Type",
      formatter: buttonFormatter,
      align: "center",
      headerAlign: "center",
    },
    {
      dataField: "value",
      text: "Valeur %",
      align: "center",
      headerAlign: "center",
    },
    {
      dataField: "idRate",
      text: "Supprimer",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
      formatter: (cell, row, rowIndex, extraData) => (
        <span>
          <button className="btn btn-danger">
            <i class="fas fa-trash"></i>
          </button>
        </span>
      ),
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          console.log("rateTableData cell", rateTableData);

          setRateTableData(
            rateTableData.filter((item) => item.idRate !== row.idRate)
          );
        },
      },
    },
  ];
  function handleTableChangeRate({ rateTableData }) {
    return rateTableData;
  }

  function productDetail() {
    if (showProduct) {
      if (typeProduct === 1) {
        return (
          <>
            {" "}
            <div class="row">
              <div className="col-sm-4">
                <div className="form-group">
                  <label>
                    Prix.U.H.T <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    onChange={onChangeUnitPriceHandler}
                    type="number"
                    value={unitPrice}
                    min="0.000001"
                    id="unitPrice"
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-sm-4">
                <div className="form-group">
                  <label>
                    Quantité <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    onChange={onChangeQuantityHandler}
                    value={quantity}
                    type="number"
                    min="0"
                    id="quantity"
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-sm-4">
                <div className="form-group">
                  <label>
                    TVA <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    value={tva}
                    onChange={onChangeTvaHandler}
                    type="number"
                    min="0"
                    id="tva"
                    className="form-control"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div className="col-sm-4">
                <div className="form-group">
                  <label>
                    Produit local/import <span style={{ color: "red" }}>*</span>
                  </label>
                  <Select
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    defaultValue={selectedOptionMode}
                    onChange={onChangeSelectedMode}
                    options={allModeProduct}
                    placeholder={modeProductSelectPlaceHolder}
                  />
                </div>
              </div>
              {devise()}
            </div>
            <div class="row">
              <div className="col-sm-4">
                <div className="form-group">
                  <label>Choisir le type de promotion</label>
                  <select
                    value={promotionType}
                    onChange={(e) => setPromotionType(e.target.value)}
                    className="form-control select2"
                    style={{ width: "100%" }}
                  >
                    <option key={1} value={"pourcentage"} selected="selected">
                      Pourcentage
                    </option>
                    <option key={2} value={"montant"}>
                      Montant
                    </option>
                  </select>
                </div>
              </div>
              <div className="col-sm-4">
                <div className="form-group">
                  <label htmlFor="inputClientCompany">Promotion</label>
                  <input
                    value={promotionPercentage}
                    onChange={onChangePromotionHandler}
                    type="number"
                    min="0"
                    id="promotion"
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-sm-4">
                <div className="form-group">
                  <label>Choisir un Lot</label>

                  <Select
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    defaultValue={selectedOptionLot}
                    onChange={onChangeSelectedLot}
                    options={allLot}
                    placeholder={lotSelectPlaceHolder}
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div className="col-sm-12  text-center">
                <button
                  style={{ marginBottom: 20 }}
                  className="btn btn-dark"
                  onClick={onAddProductToList}
                >
                  <i class="fas fa-plus"></i>
                  Liste des achats{" "}
                </button>
              </div>
            </div>
          </>
        );
      } else if (typeProduct === 2) {
        return (
          <>
            {" "}
            <div class="row">
              <div className="col-sm-4">
                <div className="form-group">
                  <label>Prix.U.H.T</label>
                  <input
                    onChange={onChangeUnitPriceHandler}
                    type="number"
                    value={unitPrice}
                    min="0"
                    id="unitPrice"
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-sm-4">
                <div className="form-group">
                  <label>Quantité</label>
                  <input
                    onChange={onChangeQuantityHandler}
                    value={quantity}
                    type="number"
                    min="0"
                    id="quantity"
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-sm-4">
                <div className="form-group">
                  <label>TVA </label>
                  <input
                    value={tva}
                    onChange={onChangeTvaHandler}
                    type="number"
                    min="0"
                    id="tva"
                    className="form-control"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div className="col-sm-4">
                <div className="form-group">
                  <label>Produit local/import</label>
                  <Select
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    defaultValue={selectedOptionMode}
                    onChange={onChangeSelectedMode}
                    options={allModeProduct}
                    placeholder={modeProductSelectPlaceHolder}
                  />
                </div>
              </div>
              {devise()}
            </div>
            <div class="row">
              <div className="col-sm-6">
                <div className="form-group">
                  <label>Choisir le type de promotion</label>
                  <select
                    value={promotionType}
                    onChange={(e) => setPromotionType(e.target.value)}
                    className="form-control select2"
                    style={{ width: "100%" }}
                  >
                    <option key={1} value={"pourcentage"} selected="selected">
                      Pourcentage
                    </option>
                    <option key={2} value={"montant"}>
                      Montant
                    </option>
                  </select>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="form-group">
                  <label htmlFor="inputClientCompany">Promotion</label>
                  <input
                    value={promotionPercentage}
                    onChange={onChangePromotionHandler}
                    type="number"
                    min="0"
                    id="promotion"
                    className="form-control"
                  />
                </div>
              </div>
              {/* <div className="col-sm-4">
                <div className="form-group">
                  <label>Choisir un Lot</label>

                  <Select
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    defaultValue={selectedOptionLot}
                    onChange={onChangeSelectedLot}
                    options={allLot}
                    placeholder={lotSelectPlaceHolder}
                  />
                </div>
              </div> */}
            </div>
            <div class="row">
              <div className="col-sm-12  text-center">
                <button
                  style={{ marginBottom: 20 }}
                  className="btn btn-dark"
                  onClick={onAddProductToList}
                >
                  <i class="fas fa-plus"></i>
                  Liste des achats{" "}
                </button>
              </div>
            </div>
          </>
        );
      }
    }
  }
     useEffect(() => {
        const handler = setTimeout(() => {
          if (searchData) {
            searchProduct();
          }
        }, 500); // Delay in milliseconds (adjust as needed)
    
        return () => {
          clearTimeout(handler); // Cleanup on unmount or when searchInput changes
        };
      }, [searchData]);
  const handleInputChange = (searchData) => {
    setSearchData(searchData);
  };
  const searchProduct = (e) => {
    setAllProducts([]);
    startLoading()
    ProductService.getAllProductsOnPurshaseAndServiceUsingSearch(
      getCurrentUserId(),
      1,
      2, searchData
    ).then((response) => {
      console.log("products devis", response.data["Allproducts"]);
      setAvailableProducts(response.data["Allproducts"]);
      response.data["Allproducts"] &&
        response.data["Allproducts"].map((element) => {
          let exist = false;
          if (allProducts.length !== 0) {
            for (let index = 0; index < allProducts.length; index++) {
              if (allProducts[index].value === element?.id) {
                exist = true;
                break;
              }
            }
          }
          let codeProduct = "*";
          if (element.productCode !== undefined) {
            codeProduct = element.productCode;
          }
          let barCodeProduct = "*";
          if (element.barcode) {
            barCodeProduct = element.barcode;
          }
          let label = codeProduct + "-" + barCodeProduct + "-" + element.name;
          if (element?.id !== undefined && exist === false) {
            setAllProducts((oldArray) => [
              ...oldArray,
              {
                value: element.id,
                label: label,
                customElements: element.typeProduct,
              },
            ]);
          }
        });
    }).catch((error) => {
      console.log(error);
    }).finally(() => {
      stopLoading()
    });

  }
  function getStepContent(step) {
    switch (step) {
      case 0:
        return (
          <div>
            <div class="row">
              <div className="col-sm-12">
                <div className="form-group">
                  <label>
                    Vous pouvez choisir la référence d'un devis existant pour
                    obtenir ses produits
                  </label>

                  <div className="input-group">
                    <div
                      className="input-group-prepend"
                      style={{ width: "95%" }}
                    >
                      <Select
                        styles={styles}
                        closeMenuOnSelect={true}
                        components={animatedComponents}
                        defaultValue={availableDevisSelectedOption}
                        onChange={onChangeQuotationReferenceHandler}
                        options={allAvailableDevis}
                        placeholder={availableDevisSelectPlaceHolder}
                      />
                    </div>
                    <div className=" input-group-append">
                      <button
                        onClick={onGetQuotationByReference}
                        type="button"
                        class="btn btn-dark"
                      >
                        <i class="fas  fa-solid fa-arrow-down"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
           <div class="row">
                                  <div className="col-sm-12">
                                    <div className="form-group">
                    
                                      <div className="input-group">
                                        <label>Choisir un produit <span style={{ color: "red" }}>*</span></label>
                                      </div>
                                       <div className="col-sm-12">
                                          <Select
                                              closeMenuOnSelect={true}
                                              components={animatedComponents}
                                              defaultValue={selectedOption}
                                              onChange={onChangeSelectedProduct}
                                              onInputChange={handleInputChange}

                                              options={allProducts}
                                              placeholder={productSelectPlaceHolder}
                                            />
                                      </div>
                                      <br />
                                   
                    
                                    </div>
                                  </div>
                                </div>
            {productDetail()}
            <div class="row">
              <div className="col-sm-12">
                <div className="form-group">
                  {productTableData && (
                    <ToolkitProvider
                      keyField="idProduct"
                      data={productTableData}
                      columns={columns}
                      onTableChange={handleTableChange}
                    >
                      {(props) => (
                        <div className="row">
                          <BootstrapTable
                            {...props.baseProps}
                            headerClasses="thead-light"
                            wrapperClasses="table-responsive w-100"
                            striped
                            hover
                            condensed
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  )}
                </div>
              </div>
            </div>
          </div>
        );
      case 1:
        return (
          <div>
            <div className="row">
              <div className="col-sm-6">
                <div className="form-group">
                  <label>
                    Réference devis fournisseur{" "}
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    value={devisReference}
                    onChange={onChangeDevisHandler}
                    id="inputClientCompany"
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="form-group">
                  <label htmlFor="inputClientCompany">
                    Titre devis fournisseur{" "}
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    value={ordreTitle}
                    required="required"
                    onChange={onChangeOrdreTitleHandler}
                    type="text"
                    id="inputClientCompany"
                    className="form-control"
                    placeholder="Saisir..."
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-4">
                <div className="form-group">
                  <label>
                    Choisir le Fournisseur{" "}
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <Select
                    styles={styles}
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    defaultValue={supplierSelectedOption}
                    onChange={onChangeSelectedSupplier}
                    options={allSuppliers}
                    placeholder={supplierSelectPlaceHolder}
                  />
                </div>
              </div>
              <div className="col-sm-4">
                <div className="form-group">
                  <label>Choisir le type de Remise </label>
                  <select
                    value={discountType}
                    onChange={onChangeDiscountTypeHandler}
                    className="form-control select2"
                    style={{ width: "100%" }}
                  >
                    <option key={1} value={"pourcentage"} selected="selected">
                      Pourcentage
                    </option>
                    <option key={2} value={"montant"}>
                      Montant
                    </option>
                  </select>
                </div>
              </div>
              <div className="col-sm-4">
                <div className="form-group">
                  <label htmlFor="inputClientCompany">Remise</label>
                  <input
                    value={discount}
                    onChange={onChangeDiscountHandler}
                    type="number"
                    min="0"
                    id="inputRemiseClientCompany"
                    className="form-control"
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="form-group">
                  <label htmlFor="inputDescription">
                    Note <span style={{ color: "red" }}>*</span>
                  </label>
                  <textarea
                    value={ordreDesignation}
                    placeholder="Saisir..."
                    onChange={onChangeOrdreDesignationHandler}
                    id="inputDescription"
                    className="form-control"
                    rows={4}
                    defaultValue={""}
                    required
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div class="form-group">
                  <label for="exampleInputFile">Devis </label>
                  <div class="input-group">
                    <div class="custom-file">
                      <input
                        accept="application/pdf, .jpg, .jpeg, .png"
                        type="file"
                        className="custom-file-input"
                        id="exampleInputFile"
                        onChange={onUploadFileHandler}
                      />
                      <label class="custom-file-label" for="exampleInputFile">
                        Entrer le fichier de devis
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div className="col-sm-6">
                <div className="form-group">
                  <label>Choisir une taxe</label>
                  <Select
                    styles={styles}
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    defaultValue={selectedOptionRate}
                    onChange={onChangeSelected}
                    options={allRates}
                    placeholder={rateSelectPlaceHolder}
                  />
                </div>
              </div>
              {blocRates()}
              <br />{" "}
            </div>
            {blocButtonAddRates()}

            <br />
            <div className="row">
              <div className="col-md-12">
                {rateTableData && (
                  <ToolkitProvider
                    keyField="rateTable"
                    data={rateTableData}
                    columns={columnsRate}
                    onTableChange={handleTableChangeRate}
                  >
                    {(props) => (
                      <div>
                        <div className="row">
                          <BootstrapTable
                            {...props.baseProps}
                            headerClasses="thead-light"
                            wrapperClasses="table-responsive w-100"
                            striped
                            hover
                            condensed
                          />
                        </div>
                      </div>
                    )}
                  </ToolkitProvider>
                )}
              </div>
            </div>
            <div className="row bg-light">
              <div className="col-sm-6">
                <div className="form-group">
                  <label htmlFor="inputClientCompany">Prix total Ht </label>
                  <input
                    value={devisPriceHt}
                    disabled="true"
                    id="inputClientCompany"
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="form-group">
                  <label htmlFor="inputClientCompany">Prix total Tt </label>
                  <input
                    value={discount !== 0 ? devisPriceTt : devisPriceTt}
                    disabled="true"
                    id="inputClientCompany"
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-sm-12"></div>
            </div>
          </div>
        );
      case 2:
        return (
          <div className="row">
            <span class="text-dark">
              Avant de cliquer sur terminé, vous devez être sûr des informations
              saisies
            </span>
          </div>
        );
      default:
        return "Unknown step";
    }
  }

  const columns = [
    {
      dataField: "productRef",
      text: "Libellé",
      headerAlign: "center",
    },
    {
      dataField: "initialPriceHtc",
      text: "Prix.U.HT",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "12%" };
      },
    },
    {
      dataField: "buyingPriceU",
      text: "Prix U.A",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "12%" };
      },
    },
    {
      dataField: "quantity",
      text: "Qte",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "6%" };
      },
    },
    {
      dataField: "tva",
      text: "TVA",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "6%" };
      },
    },
    {
      dataField: "htPrice",
      text: "Montant.HT",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "12%" };
      },
    },
    {
      dataField: "ttPrice",
      text: "Montant.TT",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "12%" };
      },
    },
    {
      dataField: "promotionPercentage",
      text: "Remise",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },
    {
      dataField: "idProduct",
      text: "Supprimer",
      formatter: (cell, row, rowIndex, extraData) => (
        <span>
          <button className="btn btn-danger">
            <i class="fas fa-trash"></i>
          </button>
        </span>
      ),
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          console.log("productTableData", productTableData);

          setProductTableData(
            productTableData.filter((item) => item.idProduct !== row.idProduct)
          );
        },
      },
    },
  ];
  function handleTableChange({ productTableData }) {
    return productTableData;
  }

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };

  const onAddProductToList = (event) => {
    let productRef = null;
    let exist = false;
    let indexInDataTable;
    try {
      productMapById.forEach((element, index) => {
        if (element.idProduct === productId) {
          indexInDataTable = index;
          exist = true;
          throw "Break";
        }
      });
    } catch (e) {
      if (e !== "Break") throw e;
    }

    try {
      availableProducts.forEach((element) => {
        if (element.id === productId) {
          productRef = element.name;
          throw "Break";
        }
      });
    } catch (e) {
      if (e !== "Break") throw e;
    }
    if (productId === 0) {
      setOpenErrorAlert(true);
      setErrorAlertText("Sélectionnez un produit ");
    } else if (quantity === 0 || quantity < 0) {
      setOpenErrorAlert(true);
      setErrorAlertText("La quantité doit être supérieur à 0 ");
    } else if (unitPrice === 0 || unitPrice < 0) {
      setOpenErrorAlert(true);
      setErrorAlertText("Le prix unitaire doit être supérieur à 0 ");
    } else {
      if (modeProduct === 0) {
      }
      let result = UtilsFormule.CalculatePromotionProductPurchase(
        promotionPercentage,
        promotionType,
        montantDevis,
        quantity,
        tva
      );
      let promotionAmountOrPersentage = result[0];
      let buyingPriceU = result[1];
      let promotionpercent = result[2];
      let ttPrice = result[3];

      if (!exist) {
        setProductMapById((previoustate) => [
          ...previoustate,
          {
            productRef: productRef,
            idProduct: productId,
            initialPriceHtc: montantDevis,
            quantity: quantity,
            tva: tva,
            currency: deviseChoosen,
            currencyPrice: unitPrice,
            exchangeRate: tauxChange,
            isImport: modeProduct,
            buyingPriceU: buyingPriceU,
            idLot: idLot,
            htPrice: promotionAmountOrPersentage,
            ttPrice: ttPrice,
            promotionPercentage: promotionpercent,
          },
        ]);
        setProductTableData((previoustate) => [
          ...previoustate,
          {
            productRef: productRef,
            idProduct: productId,
            initialPriceHtc: montantDevis,
            quantity: quantity,
            tva: tva,
            idLot: idLot,
            buyingPriceU: buyingPriceU,
            currency: deviseChoosen,
            currencyPrice: unitPrice,
            exchangeRate: tauxChange,
            isImport: modeProduct,
            htPrice: promotionAmountOrPersentage,
            ttPrice: ttPrice,
            promotionPercentage: promotionpercent,
          },
        ]);
      } else if (exist) {
        let productUpdateValue = productTableData[indexInDataTable];
        productUpdateValue.promotionPercentage = promotionPercentage;
        productUpdateValue.initialPriceHtc = montantDevis;
        productUpdateValue.quantity = quantity;
        productUpdateValue.tva = tva;
        productUpdateValue.buyingPriceU = buyingPriceU;
        productUpdateValue.htPrice = promotionAmountOrPersentage;
        productUpdateValue.ttPrice = ttPrice;

        let modelData = update(productTableData, {
          [indexInDataTable]: { $merge: productUpdateValue },
        });

        let tableData = update(productMapById, {
          [indexInDataTable]: { $merge: productUpdateValue },
        });
        if (productTableData[indexInDataTable].initialPriceHtc !== unitPrice) {
          setOpenInfoAlert(true);
          setInfoAlertText(
            "Info : Vous avez actualisé le prix unitaire du produit :  " +
            productRef
          );
        } else if (
          productTableData[indexInDataTable].promotionType !== promotionType
        ) {
          setOpenInfoAlert(true);
          setInfoAlertText(
            "Info : Vous avez actualisé le type de promotion du produit :  " +
            productRef
          );
        } else if (
          productTableData[indexInDataTable].promotionPercentage !==
          promotionPercentage
        ) {
          setOpenInfoAlert(true);
          setInfoAlertText(
            "Info : Vous avez actualisé la promotion du produit : " + productRef
          );
        } else if (productTableData[indexInDataTable].quantity !== quantity) {
          setOpenInfoAlert(true);
          setInfoAlertText(
            "Info : Vous avez actualisé la quantité du produit : " + productRef
          );
        } else if (productTableData[indexInDataTable].tva !== tva) {
          setOpenInfoAlert(true);
          setInfoAlertText(
            "Info : Vous avez actualisé le tva du produit : " + productRef
          );
        }

        setProductMapById(tableData);
        setProductTableData(modelData);
      }
    }
    etatInitial();

    // console.log("productTableData ", productTableData);
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <style>{`
        .quotation-form .form-group > label,
        .quotation-form .input-group > label {
          font-size: 0.8rem;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.03em;
          color: #6c757d;
        }
      `}</style>
      <section className="content-header">
        <div className="container-fluid">
          <div className="d-flex flex-wrap justify-content-between align-items-center">
            <div>
              <h4 className="mb-1">
                <i className="fas fa-file-alt mr-2"></i>Nouveau devis d'achat
              </h4>
              <small className="text-muted">
                Saisissez les produits, les informations du fournisseur puis
                validez le devis
              </small>
            </div>
            <button
              className="btn btn-outline-secondary mt-2 mt-sm-0"
              onClick={() => navigate("/allQuotation")}
            >
              <i className="fas fa-arrow-left mr-1"></i>
              Retour aux devis
            </button>
          </div>
        </div>
      </section>
      <section className="content ">
        <div className="container-fluid">
          <div className="row mt-3">
            <div className="col-md-12">
              <div
                className="card card-outline card-dark quotation-form"
                style={{ borderRadius: 8, boxShadow: "0 1px 6px rgba(0,0,0,.08)" }}
              >
                <div className="card-header">
                  <div className={classes.root}>
                    <Stepper activeStep={activeStep}>
                      {steps.map((label) => (
                        <Step key={label}>
                          <StepLabel>{label}</StepLabel>
                        </Step>
                      ))}
                    </Stepper>
                  </div>
                </div>

                {activeStep === steps.length ? (
                  <div>
                    <div className="card-body text-center py-5">
                      <i
                        className="fas fa-check-circle fa-3x mb-3 d-block"
                        style={{ color: "#28a745" }}
                      ></i>
                      <h5>Toutes les étapes ont été complétées avec succès</h5>
                    </div>
                    <div className="card-footer text-right">
                      <button className="btn btn-dark" onClick={handleReset}>
                        <i className="fas fa-undo mr-1"></i>
                        Nouveau devis
                      </button>
                    </div>
                  </div>
                ) : (
                  <div>
                    <div className="card-body">{getStepContent(activeStep)}</div>
                    <div className="card-footer d-flex justify-content-between">
                      <button
                        disabled={activeStep === 0}
                        className="btn btn-outline-secondary"
                        onClick={handleBack}
                      >
                        <i className="fas fa-arrow-left mr-1"></i>
                        Précédent
                      </button>

                      <button className="btn btn-dark" onClick={handleNext}>
                        {activeStep === steps.length - 1 ? (
                          <>
                            <i className="fas fa-check mr-1"></i>Terminer
                          </>
                        ) : (
                          <>
                            Suivant<i className="fas fa-arrow-right ml-1"></i>
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      <Snackbar
        open={openInfoAlert}
        autoHideDuration={4000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleInfoClose} severity="info">
          {infoAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default withLoader(AddProductQuotation);
